const updates = [
  {
    id: 1,
    date: '2026-07-30',
    title: '《流浪地球3》高清版正式上线',
    desc: '国产科幻巨制续作，吴京、刘德华主演，全网首发高清版本，即日起可在苹果视频免费观看。',
    tag: '新片上线',
    tagClass: 'bg-primary-100 text-primary-700',
  },
  {
    id: 2,
    date: '2026-07-28',
    title: '暑期档专题策划上线',
    desc: '精选暑期最热门电影和电视剧，涵盖科幻、喜剧、动作、动画等多种类型，陪你度过精彩夏天。',
    tag: '专题更新',
    tagClass: 'bg-accent-100 text-accent-700',
  },
  {
    id: 3,
    date: '2026-07-25',
    title: '播放器全面升级 · 4K超清上线',
    desc: '苹果视频播放器升级至最新版本，新增4K超清画质选项，支持HDR显示，观影体验全面飞跃。',
    tag: '功能升级',
    tagClass: 'bg-secondary-100 text-secondary-700',
  },
  {
    id: 4,
    date: '2026-07-22',
    title: '日漫新番专区开放',
    desc: '2026年夏季日漫新番正式上线，包括多部热门续作和全新IP，二次元爱好者不容错过。',
    tag: '内容扩充',
    tagClass: 'bg-primary-100 text-primary-700',
  },
  {
    id: 5,
    date: '2026-07-20',
    title: '经典港片高清修复计划启动',
    desc: '首批50部经典港片完成高清修复，周星驰、成龙、周润发等巨星代表作画质焕新，重温黄金年代。',
    tag: '经典重映',
    tagClass: 'bg-accent-100 text-accent-700',
  },
  {
    id: 6,
    date: '2026-07-18',
    title: '智能推荐算法上线 · 发现更多好片',
    desc: '基于用户观看偏好的智能推荐系统正式启用，帮你快速发现感兴趣的电影和电视剧。',
    tag: '功能升级',
    tagClass: 'bg-secondary-100 text-secondary-700',
  },
  {
    id: 7,
    date: '2026-07-15',
    title: '移动端观影体验优化',
    desc: '针对手机和平板设备全面优化界面和播放体验，触控操作更流畅，数据流量播放更省流量。',
    tag: '体验优化',
    tagClass: 'bg-primary-100 text-primary-700',
  },
  {
    id: 8,
    date: '2026-07-12',
    title: '西瓜视频免费频道内容全面接入',
    desc: '苹果视频与西瓜视频免费频道深度合作，海量独家内容现已可在平台直接观看，资源库再扩容。',
    tag: '合作扩展',
    tagClass: 'bg-accent-100 text-accent-700',
  },
  {
    id: 9,
    date: '2026-07-10',
    title: '纪录片频道独立上线 · 1000+精选',
    desc: '纪录片频道从综合分类中独立出来，精选超过1000部优质纪录片，涵盖自然、历史、科技等主题。',
    tag: '新版块',
    tagClass: 'bg-secondary-100 text-secondary-700',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-16 md:py-24 bg-background-100">
      <div className="max-w-[900px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            最新动态
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-[600px] mx-auto">
            苹果视频的最新更新和重要公告
          </p>
        </div>

        <div className="relative">
          <div className="absolute left-[19px] top-0 bottom-0 w-px bg-secondary-200 hidden sm:block"></div>

          <div className="space-y-6">
            {updates.map((item) => (
              <div key={item.id} className="relative flex gap-6">
                <div className="hidden sm:flex w-10 shrink-0 justify-center">
                  <div className="w-2.5 h-2.5 rounded-full bg-primary-500 mt-1.5 relative z-10 ring-4 ring-background-100"></div>
                </div>
                <div className="flex-1 bg-background-50 rounded-xl p-5 transition-all duration-300 hover:scale-[1.01] cursor-pointer">
                  <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 mb-3">
                    <span className="text-xs text-foreground-400 whitespace-nowrap">{item.date}</span>
                    <span className={`px-2.5 py-0.5 rounded-md text-xs font-medium w-fit ${item.tagClass}`}>
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm md:text-base font-semibold text-foreground-900 mb-2">
                    {item.title}
                  </h3>
                  <p className="text-sm text-foreground-500 leading-relaxed">
                    {item.desc}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}